import {
  MIN_DURATION_FOR_MONTHLY_PAYMENT,
  parseDuration,
  ProgramDurationUnitEnum,
} from '../duration';
import {MIN_PRICE} from './constants';

export const isMonthlyPaymentAvailable = (
  payment: number = 0,
  duration: number = 0,
): boolean => {
  const parsedDuration = parseDuration(duration);

  return (
    parsedDuration.unit.id === ProgramDurationUnitEnum.MONTH.id &&
    duration >= MIN_DURATION_FOR_MONTHLY_PAYMENT &&
    payment >= MIN_PRICE
  );
};
